import { useState } from "react"
import classNames from "classnames"
import { API_DOC_SECTIONS } from "./apiDocsCatalog"

export function ApiDocsTabContent() {
    const [activeSectionId, setActiveSectionId] = useState(API_DOC_SECTIONS[0].id)
    const activeSection =
        API_DOC_SECTIONS.find((section) => section.id === activeSectionId) ?? API_DOC_SECTIONS[0]

    return (
        <div className="flex gap-6 px-2 py-6 h-full">
            <div className="flex flex-col gap-1 w-[220px] shrink-0 overflow-y-auto border-r border-white-100 pr-2">
                {API_DOC_SECTIONS.map((section) => (
                    <button
                        key={section.id}
                        type="button"
                        onClick={() => setActiveSectionId(section.id)}
                        className={classNames(
                            "w-full text-[14px] text-left px-2 py-2.5 rounded-md",
                            section.id === activeSection.id
                                ? "bg-white-100 text-gray-0"
                                : "text-gray-100 hover:bg-white-100"
                        )}
                    >
                        {section.title}
                    </button>
                ))}
            </div>

            <div className="flex-1 min-w-0 max-w-[760px] overflow-y-auto pb-6">
                <h2 className="text-[22px] text-gray-0 telegraf mb-5">{activeSection.title}</h2>
                <div className="flex flex-col gap-4">
                    {activeSection.paragraphs.map((paragraph, i) => (
                        <p key={i} className="text-[15px] text-gray-100 leading-relaxed">
                            {paragraph}
                        </p>
                    ))}
                    {activeSection.table && (
                        <div className="overflow-hidden rounded border border-gray-700">
                            <table className="w-full text-[14px] text-gray-100">
                                <thead>
                                    <tr className="bg-gray-800">
                                        {activeSection.table.headers.map((header) => (
                                            <th
                                                key={header}
                                                className="text-left px-4 py-2.5 text-gray-300 text-[11px] uppercase tracking-wide"
                                            >
                                                {header}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {activeSection.table.rows.map((row, i) => (
                                        <tr key={i} className="border-t border-gray-700">
                                            {row.map((cell, j) => (
                                                <td
                                                    key={j}
                                                    className="px-4 py-2.5 font-mono text-gray-0"
                                                >
                                                    {cell}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                    {activeSection.code && (
                        <div>
                            <div className="text-[11px] uppercase tracking-wide text-gray-300 mb-1">
                                {activeSection.code.label}
                            </div>
                            <pre className="bg-gray-800 border border-gray-700 rounded p-3 text-[13px] font-mono text-gray-0 whitespace-pre-wrap">
                                {activeSection.code.snippet}
                            </pre>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
